export default {
      id: "SW_fb-usage",
      viewBox: "0 0 10.74 21.54",
      url: "../dist/images/" + "sprite.svg#SW_fb-usage",
      toString: function () {
        return this.url;
      }
    }